// <layflags-rolling-number value="123" />
// Sourced and modified from https://github.com/layflags/rolling-number

const ZWSP = '​'

const styles = `
  :host { --roll-duration: 1s; }
  .digit {
    width: 1ch;
    overflow: hidden;
    display: inline-flex;
    position: relative;
  }
  .value { color: transparent; position: relative; }
  .scale {
    user-select: none;
    position: absolute;
    left: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    transition: transform var(--roll-duration);
  }
  .scale span:last-child { position: absolute; bottom: -10%; left: 0; }
  [data-value="${ZWSP}"] .scale { transform: translateY(10%); }
  [data-value="0"] .scale { transform: translateY(0); }
  [data-value="1"] .scale { transform: translateY(-10%); }
  [data-value="2"] .scale { transform: translateY(-20%); }
  [data-value="3"] .scale { transform: translateY(-30%); }
  [data-value="4"] .scale { transform: translateY(-40%); }
  [data-value="5"] .scale { transform: translateY(-50%); }
  [data-value="6"] .scale { transform: translateY(-60%); }
  [data-value="7"] .scale { transform: translateY(-70%); }
  [data-value="8"] .scale { transform: translateY(-80%); }
  [data-value="9"] .scale { transform: translateY(-90%); }
  [data-value="-"] .scale { transform: translateY(-100%); }
`

const SCALE_DIGITS = '<span>0</span><span>1</span><span>2</span><span>3</span>'
  + '<span>4</span><span>5</span><span>6</span><span>7</span>'
  + `<span>8</span><span>9</span><span>${ZWSP}</span>`

function digitHtml(value, index) {
  return `<span class="digit" data-value="${value}" id="digit${index}">`
    + `<span class="scale" aria-hidden="true">${SCALE_DIGITS}</span>`
    + `<span class="value">${value}</span>`
    + `</span>`
}

function placeholderFor(nextStr, prevStr, prevSize) {
  if (prevSize === 0) return Array(nextStr.length).fill('0')

  if (nextStr.length > prevSize) {
    return [
      ...Array(nextStr.length - prevSize).fill(ZWSP),
      ...Array(prevSize).fill('0'),
    ]
  }

  const padding = Array(Math.max(0, nextStr.length - prevStr.length)).fill(ZWSP)
  return [...padding, ...prevStr.split('')]
}

function render($wrapper, nextStr, prevStr, prevSize) {
  const placeholder = placeholderFor(nextStr, prevStr, prevSize)
  $wrapper.innerHTML = placeholder.map(digitHtml).join('')

  // Two RAFs so the browser commits the placeholder before we transition to the new value.
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      nextStr.split('').forEach((digit, i) => {
        const el = $wrapper.querySelector(`#digit${i}`)
        if (!el) return
        el.dataset.value = digit
        el.querySelector('.value').textContent = digit
      })
    })
  })
}

class RollingNumber extends HTMLElement {
  static get observedAttributes() { return ['value'] }

  #wrapper = null
  #value = NaN
  #size = 0

  constructor() {
    super()
    const shadow = this.attachShadow({ mode: 'open' })
    shadow.innerHTML = `<style>${styles}</style><span id="wrapper"></span>`
    this.#wrapper = shadow.getElementById('wrapper')
  }

  get value() { return this.#value }

  set value(val) {
    const nextStr = String(val)
    const prevStr = String(this.#value)
    render(this.#wrapper, nextStr, prevStr, this.#size)
    this.#value = val
    this.#size = nextStr.length
  }

  attributeChangedCallback(name, _, newVal) {
    if (name === 'value') this.value = newVal
  }
}

customElements.define('layflags-rolling-number', RollingNumber)
export { RollingNumber }
